/** Imágenes por defecto del home (assets locales = branding actual en prod). */
export const DEFAULT_HERO_IMAGE = '/hero-default.png';

export const DEFAULT_CLINIC_SECTION_IMAGE = '/clinic-section-default.png';

export const DEFAULT_BRAND_NAME = 'Centro Cultural';

export const DEFAULT_HOME_FEATURES = [
  { icon: 'shield', title: 'Profesionalismo', desc: 'Personal certificado y capacitado' },
  { icon: 'heart', title: 'Cuidado Integral', desc: 'Atención personalizada para cada paciente' },
  { icon: 'clock', title: 'Puntualidad', desc: 'Respetamos tu tiempo' },
  { icon: 'calendar', title: 'Flexibilidad', desc: 'Horarios que se adaptan a ti' },
];

export const DEFAULT_SERVICES_BULLETS = [
  'Tratamiento de esguinces',
  'Torceduras',
  'Rehabilitación física',
];

export const DEFAULT_FOOTER_BLURB =
  'Especialistas en el cuidado de tu cuerpo. Brindamos atención profesional y personalizada para tu bienestar.';

/** Secciones del editor (mapa del home). */
export const HOME_EDITOR_SECTIONS = [
  { id: 'edit-brand', title: 'Marca y contacto', description: 'Cabecera, pie y página /contacto' },
  { id: 'edit-hero', title: 'Hero (inicio)', description: 'Banner principal al entrar al sitio' },
  { id: 'edit-features', title: 'Tarjetas de valores', description: 'Cuatro columnas bajo el hero' },
  { id: 'edit-services', title: 'Servicios (lista)', description: 'Viñetas con imagen lateral' },
  { id: 'edit-products', title: 'Productos destacados', description: 'Catálogo en el home (tarjetas desde Admin → Productos)' },
  { id: 'edit-reviews', title: 'Reseñas en el home', description: 'Título de opiniones (contenido desde Admin → Reseñas)' },
  { id: 'edit-cta', title: 'Llamada a la acción', description: 'Franja verde «Agendar cita»' },
  { id: 'edit-contact', title: 'Contacto en el home', description: 'Título del bloque «Encuéntranos»' },
  { id: 'edit-hours', title: 'Horarios (texto)', description: 'Columna de horarios en contacto y pie' },
];

/** Metadatos para etiquetas y ayuda en el editor. */
export const CLINIC_FIELD_META = {
  name: {
    label: 'Nombre de la empresa / clínica',
    hint: 'Logo, título de pestaña del navegador y nombre visible en cabecera y pie.',
    section: 'brand',
  },
  logo_url: {
    label: 'Logotipo',
    hint: 'Imagen en la barra de navegación y pie del sitio.',
    section: 'brand',
  },
  site_tagline_short: {
    label: 'Línea corta (barra superior verde)',
    hint: 'Texto a la derecha en la franja verde superior. Si está vacío, se usa la dirección resumida.',
    section: 'brand',
  },
  phone: {
    label: 'Teléfono',
    hint: 'Barra superior, pie, home y /contacto. Al hacer clic abre WhatsApp (PC y móvil).',
    section: 'brand',
  },
  email: {
    label: 'Correo de contacto',
    hint: 'Barra superior (pantallas anchas), pie y bloque de contacto del home.',
    section: 'brand',
  },
  address: {
    label: 'Dirección',
    hint: 'Texto visible en pie, home y /contacto. Al hacer clic abre Google Maps (PC y móvil). Puede ser la dirección escrita o un enlace «Compartir» de Google Maps.',
    section: 'brand',
  },
  description: {
    label: 'Descripción breve',
    hint: 'Texto introductorio en la página /contacto.',
    section: 'brand',
  },
  footer_blurb: {
    label: 'Texto del pie (columna izquierda)',
    hint: 'Párrafo bajo el logo en el pie verde del sitio.',
    section: 'brand',
  },
  copyright_name: {
    label: 'Nombre en copyright',
    hint: 'Línea «© año … Todos los derechos reservados» al final del pie.',
    section: 'brand',
  },
  hero_badge_text: {
    label: 'Distintivo (badge)',
    hint: 'Etiqueta pequeña con icono sobre el título principal del hero.',
    section: 'hero',
  },
  hero_title_prefix: {
    label: 'Título — parte antes del acento',
    hint: 'Primera parte del H1 del hero (texto en color normal).',
    section: 'hero',
  },
  hero_title_highlight: {
    label: 'Título — palabras en color primario',
    hint: 'Palabras destacadas en verde dentro del H1 del hero.',
    section: 'hero',
  },
  hero_subtitle: {
    label: 'Subtítulo del hero',
    hint: 'Párrafo bajo el título principal, antes de los botones Agendar / Ver Servicios.',
    section: 'hero',
  },
  hero_image_url: {
    label: 'Imagen principal (hero)',
    hint: 'Fotografía grande a la derecha del texto en la parte superior del home.',
    section: 'hero',
  },
  services_section_title: {
    label: 'Título de la sección',
    hint: 'Encabezado H2 de la sección con viñetas e imagen lateral (mitad del home).',
    section: 'services',
  },
  services_section_intro: {
    label: 'Párrafo introductorio',
    hint: 'Texto bajo el título de «Nuestros Servicios».',
    section: 'services',
  },
  services_bullets: {
    label: 'Ítems de servicio (uno por línea)',
    hint: 'Lista con viñetas verdes en la sección de servicios del home.',
    section: 'services',
  },
  clinic_section_image_url: {
    label: 'Imagen lateral (sección servicios)',
    hint: 'Foto a la derecha de la lista de servicios en el home.',
    section: 'services',
  },
  featured_products_title: {
    label: 'Título de la sección',
    hint: 'Encabezado centrado sobre las tarjetas de productos del catálogo en el home.',
    section: 'products',
  },
  featured_products_intro: {
    label: 'Texto introductorio',
    hint: 'Párrafo bajo el título de productos destacados (las tarjetas vienen de Admin → Productos).',
    section: 'products',
  },
  reviews_section_title: {
    label: 'Título de la sección',
    hint: 'Encabezado sobre las opiniones de pacientes (solo si hay reseñas aprobadas).',
    section: 'reviews',
  },
  cta_title: {
    label: 'Título principal',
    hint: 'Texto grande en blanco en la franja verde «Agendar cita», antes del pie.',
    section: 'cta',
  },
  cta_subtitle: {
    label: 'Subtítulo',
    hint: 'Texto secundario en blanco bajo el título de la franja verde.',
    section: 'cta',
  },
  contact_section_title: {
    label: 'Título del bloque',
    hint: 'Encabezado centrado «Encuéntranos» sobre las tarjetas de contacto y horarios.',
    section: 'contact',
  },
  footer_hours_weekdays: {
    label: 'Horario entre semana',
    hint: 'Primera línea en «Horarios de Atención» del home y columna Horarios del pie.',
    section: 'hours',
  },
  footer_hours_lunch: {
    label: 'Hora de comida',
    hint: 'Segunda línea de horarios en contacto del home y pie.',
    section: 'hours',
  },
  footer_hours_weekend: {
    label: 'Fin de semana',
    hint: 'Tercera línea de horarios en contacto del home y pie.',
    section: 'hours',
  },
};

function isBlank(value) {
  if (value == null) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (Array.isArray(value)) return value.length === 0;
  return false;
}

/** Valores por defecto de textos del home (dependen del nombre de marca). */
export function getHomeFieldDefaults(brandName = DEFAULT_BRAND_NAME) {
  const brand = String(brandName || '').trim() || DEFAULT_BRAND_NAME;
  return {
    hero_badge_text: 'Especialistas en Fisioterapia',
    hero_title_prefix: 'Cuidamos de ti',
    hero_title_highlight: '.',
    hero_subtitle: `En ${brand} brindamos atención profesional y personalizada. Tu bienestar es nuestra prioridad.`,
    services_section_title: 'Nuestros Servicios',
    services_section_intro:
      'Ofrecemos una amplia gama de tratamientos fisioterapéuticos para cuidar de tu salud.',
    featured_products_title: 'Servicios Destacados',
    featured_products_intro: 'Conoce algunos de nuestros tratamientos más solicitados',
    reviews_section_title: 'Lo que dicen nuestros pacientes',
    cta_title: '¿Listo para usar tu tiempo en lo que en realidad sí ocupas?',
    cta_subtitle: 'Agenda tu cita hoy y da el primer paso hacia tu bienestar.',
    contact_section_title: 'Encuéntranos',
    footer_hours_weekdays: 'Lunes a Viernes: 9:00 AM - 5:00 PM',
    footer_hours_lunch: 'Hora de comida: 2:00 PM - 3:00 PM',
    footer_hours_weekend: 'Sábado y Domingo: Cerrado',
    footer_blurb: DEFAULT_FOOTER_BLURB,
    copyright_name: brand,
    site_tagline_short: null,
  };
}

const OPTIONAL_TEXT_FIELDS = [
  'site_tagline_short',
  'footer_blurb',
  'hero_badge_text',
  'hero_title_prefix',
  'hero_title_highlight',
  'hero_subtitle',
  'services_section_title',
  'services_section_intro',
  'featured_products_title',
  'featured_products_intro',
  'reviews_section_title',
  'cta_title',
  'cta_subtitle',
  'contact_section_title',
  'footer_hours_weekdays',
  'footer_hours_lunch',
  'footer_hours_weekend',
  'copyright_name',
];

/** Texto efectivo que ve el visitante (info de API + defaults). */
export function resolveHomeText(field, info) {
  const brand = info?.name || DEFAULT_BRAND_NAME;
  const defaults = getHomeFieldDefaults(brand);
  const raw = info?.[field];
  if (!isBlank(raw)) return String(raw).trim();
  if (Object.prototype.hasOwnProperty.call(defaults, field)) {
    const d = defaults[field];
    return d != null ? String(d) : '';
  }
  return '';
}

/** Hidrata clinic_info para el editor: inputs muestran lo que el visitante ve. */
export function mergeClinicInfoForEditor(apiData) {
  if (!apiData || typeof apiData !== 'object') {
    return mergeClinicInfoForEditor({ name: DEFAULT_BRAND_NAME });
  }
  const brand = String(apiData.name || '').trim() || DEFAULT_BRAND_NAME;
  const defaults = getHomeFieldDefaults(brand);
  const merged = { ...apiData };

  for (const key of OPTIONAL_TEXT_FIELDS) {
    if (isBlank(merged[key]) && defaults[key] != null) {
      merged[key] = defaults[key];
    }
  }

  if (isBlank(merged.footer_blurb)) {
    merged.footer_blurb = DEFAULT_FOOTER_BLURB;
  }

  if (!Array.isArray(merged.home_features) || merged.home_features.length === 0) {
    merged.home_features = DEFAULT_HOME_FEATURES.map((f) => ({ ...f }));
  }

  if (!Array.isArray(merged.services_bullets) || !merged.services_bullets.some((s) => String(s).trim())) {
    merged.services_bullets = [...DEFAULT_SERVICES_BULLETS];
  }

  return merged;
}

/** Campos resueltos para renderizar el home desde clinic info. */
export function resolveHomeContent(info) {
  const brand = info?.name || DEFAULT_BRAND_NAME;
  const defaults = getHomeFieldDefaults(brand);

  const features =
    Array.isArray(info?.home_features) && info.home_features.length > 0
      ? info.home_features.map((x) => ({ icon: x.icon, title: x.title, desc: x.desc }))
      : DEFAULT_HOME_FEATURES;

  const services =
    Array.isArray(info?.services_bullets) && info.services_bullets.some((s) => String(s).trim())
      ? info.services_bullets
      : DEFAULT_SERVICES_BULLETS;

  return {
    brand,
    heroBadge: resolveHomeText('hero_badge_text', info) || defaults.hero_badge_text,
    heroPrefix: resolveHomeText('hero_title_prefix', info) || defaults.hero_title_prefix,
    heroHighlight: resolveHomeText('hero_title_highlight', info) || defaults.hero_title_highlight,
    heroSubtitle: resolveHomeText('hero_subtitle', info) || defaults.hero_subtitle,
    heroImg: info?.hero_image_url?.trim() || DEFAULT_HERO_IMAGE,
    features,
    services,
    servicesTitle: resolveHomeText('services_section_title', info) || defaults.services_section_title,
    servicesIntro: resolveHomeText('services_section_intro', info) || defaults.services_section_intro,
    clinicImg: info?.clinic_section_image_url?.trim() || DEFAULT_CLINIC_SECTION_IMAGE,
    prodTitle: resolveHomeText('featured_products_title', info) || defaults.featured_products_title,
    prodIntro: resolveHomeText('featured_products_intro', info) || defaults.featured_products_intro,
    reviewsTitle: resolveHomeText('reviews_section_title', info) || defaults.reviews_section_title,
    ctaTitle: resolveHomeText('cta_title', info) || defaults.cta_title,
    ctaSub: resolveHomeText('cta_subtitle', info) || defaults.cta_subtitle,
    contactTitle: resolveHomeText('contact_section_title', info) || defaults.contact_section_title,
    footerHoursWeekdays:
      resolveHomeText('footer_hours_weekdays', info) || defaults.footer_hours_weekdays,
    footerHoursLunch: resolveHomeText('footer_hours_lunch', info) || defaults.footer_hours_lunch,
    footerHoursWeekend: resolveHomeText('footer_hours_weekend', info) || defaults.footer_hours_weekend,
    addr: info?.address ?? 'Imán, Miguel Hidalgo, 43998 Cd Sahagún, Hgo.',
    phone: info?.phone ?? '+52 1 595 108 9300',
    email: info?.email ?? 'danielortegalozano@gmail.com',
  };
}
